import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { PhasrMonitoredRulesGridController } from '../controller/PhasrMonitoredRulesGridController';

export class PhasrMonitoredRulesGridWebComponent extends BaseWebComponentElement {
  public controller!: PhasrMonitoredRulesGridController;
  private _openSideMenuForFirstGridItem: boolean;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: PhasrMonitoredRulesGridController,
    });
  }

  public async reload(resetSelectionStore = false, forceResetSelectionStore = false) {
    await this.controller.view.dom.$grid.controller?.handleGridItemsLoad(resetSelectionStore, forceResetSelectionStore);
  }

  getCompanyIdFilterValue(): string {
    return this.controller?.getCompanyIdFilterValue();
  }

  set openSideMenuForFirstItem(value: boolean) {
    this._openSideMenuForFirstGridItem = value;
  }

  get openSideMenuForFirstItem() {
    return this._openSideMenuForFirstGridItem;
  }
}
